import { connect } from 'react-redux';
import { getSummary, getOvertime, getByChannel, getByCategory, getByPaymentMethod, resetPage } from '../../actions/DashboardPage';
import DashboardPage from './DashboardPage';

const mapsStateToProps = state => ({
	dashboardPageProps: state.dashboardPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getSummary(options) {
		dispatch(getSummary(options));
	},
	getOvertime(options) {
		dispatch(getOvertime(options));
	},
	getByChannel(options) {
		dispatch(getByChannel(options));
	},
	getByCategory(options) {
		dispatch(getByCategory(options));
	},
	getByPaymentMethod(options) {
		dispatch(getByPaymentMethod(options));
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(DashboardPage);
